import { createFileRoute, redirect } from "@tanstack/react-router";
import { EditCookie, EditContent } from "@/features/consent-solutions";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management/$cookieId/")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(
      userDetails,
      ["COOKIE_DEFINITION_EDIT_CUSTOM_COOKIE", "COOKIE_DEFINITION_EDIT_SCANNED_COOKIE"],
      csId,
    );

    if (!isUserPermitted) {
      redirect({
        to: "..",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <EditContent>
      <EditCookie />
    </EditContent>
  ),
});

export { Route };
